<template>
  <div>
    <el-row class="carousel">
      <el-carousel trigger="click" height="400px">
        <el-carousel-item v-for="item in carouselsList" :key="item.id">
          <img class="carousel__img" :src="item.url" alt="carousel" />
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <el-row>
      <el-col :span="16">
        <div class="grid-content">
          <el-row class="news">
            
            <el-card class="news-card">
              <div class="clearfix">
                <div class="card-title">动态新闻</div>
                <el-button type="text" style="float: right; padding: 3px 0;" @click="getNewsList()">
                  MORE
                  <i class="el-icon-caret-right"></i>
                </el-button>
              </div>
             <!-- 新闻列表 -->
              <div v-for="(item, index) in NewsList" :key="index" class="text item" >
                <router-link class="news__link" :to="'NewsDetail/'+item.id">
                  <i class="el-icon-s-promotion" style="margin-right: 10px;"></i>
                  {{ item.name }}
                </router-link>
                <span class="time">{{ item.gmtCreate }}</span>
              </div>
             <!-- 新闻列表结束 -->
            </el-card> 
          </el-row>
          <el-row class="announcements">
            <el-card class="announcements-card">
              <div class="clearfix">
                <div class="card-title">信息公告</div>
                <el-button type="text" style="float: right; padding: 3px 0;" @click="getInfoList()">
                  MORE
                  <i class="el-icon-caret-right"></i>
                </el-button>
              </div>
              <!-- 信息公告 -->
              <div v-for="(item, index) in InfoList" :key="index" class="text item" >
                <router-link class="news__link" :to="'InfoDetail/'+item.id">
                  <i class="el-icon-s-promotion" style="margin-right: 10px;"></i>
                  {{ item.name }}
                </router-link>
                <span class="time">{{ item.gmtCreate }}</span>
              </div>
             <!-- 信息公告结束 -->
            </el-card>
          </el-row>
          <el-row class="research-trends">
            <el-card class="research-trends-card">
              <div class="clearfix">
                <div class="card-title">最新研究动态</div>
                <el-button type="text" style="float: right; padding: 3px 0;" @click="getResearchList()">
                  MORE
                  <i class="el-icon-caret-right"></i>
                </el-button>
              </div>
              <!-- 研究动态 -->
              <div v-for="(item, index) in ResearchList" :key="index" class="text item" >
                <router-link class="news__link" :to="'ResearchDetail/'+item.id">
                  <i class="el-icon-s-promotion" style="margin-right: 10px;"></i>
                  {{ item.name }}
                </router-link>
                <span class="time">{{ item.gmtCreate }}</span>
              </div>
             <!-- 研究动态结束 -->
            </el-card>
          </el-row>
          <el-row class="teams">
            <el-card class="teams-card">
              <div class="clearfix">
                <div class="card-title">方向团队</div>
                <el-button type="text" style="float: right; padding: 3px 0;">
                  MORE
                  <i class="el-icon-caret-right"></i>
                </el-button>
              </div>
              <div v-for="(item, index) in teamsList" :key="index" class="text item">
                <el-link class="news__link" type="info" @click="goToDirectDetail">
                  <i class="el-icon-s-promotion" style="margin-right: 10px;"></i>
                  {{ item.info }}
                </el-link>
                <span class="time">{{ item.time }}</span>
              </div>
            </el-card>
          </el-row>
          <el-row class="achievements">
            <el-card class="achievements-card">
              <div class="clearfix">
                <div class="card-title">标志性成果</div>
                <el-button type="text" style="float: right; padding: 3px 0;">
                  MORE
                  <i class="el-icon-caret-right"></i>
                </el-button>
              </div>
              <div v-for="(item, index) in achievementsList" :key="index" class="text item">
                <el-link class="news__link" type="info" href="javascript:void(0)">
                  <i class="el-icon-s-promotion" style="margin-right: 10px;"></i>
                  {{ item.info }}
                </el-link>
                <span class="time">{{ item.time }}</span>
              </div>
            </el-card>
          </el-row>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <el-row>
            <div class="cube experimental-platform">
              <div class="cube__title experimental-platform__title">
                -实验平台资源申请-
              </div>
              <div class="cube__img">
                <img class="experimental-platform__img" src="../../assets/experimental_platform.jpeg"
                  alt="experimental_platform.jpeg" />
              </div>
              <div class="experimental-btn">
                <a href="javascript:void(0)" class="experimental-btn-link" @click="notion">
                  欢迎点击访问实验平台
                  
                </a>
              </div>
            </div>
          </el-row>
          <el-row>
            <div class="cube needs-collection__wrapper">
              <div class="cube__title needs-collection__title">
                -需求征集-
              </div>
              <el-form ref="needsForm" :model="needsForm">
                <el-form-item>
                  <el-input type="textarea" v-model="needsForm.article" :rows="4"
                    placeholder="请将您在技术开发、产品研发、科学研究方面的需求和问题告诉我们，我们将尽快与您联系，提供相关支持与服务。"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="needsForm.mobile" placeholder="请输入您的联系方式"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" class="needs-collection__btn" @click="submitNeeds">
                    提&nbsp;&nbsp;交
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
          <el-row>
            <div class="cube friendly-link__wrapper">
              <div class="cube__title friendly-link__title">
                -友情链接-
              </div>
              <div class="cube__img">
                <a href="http://xxzx.mwr.gov.cn/" class="friendly-link-link" target="_blank">
                  <img class="friendly-link__img" src="../../assets/water_conservancy.jpg"
                    alt="experimental_platform.jpeg" />
                </a>
                <a href="http://www.most.gov.cn/index.html" class="friendly-link-link" target="_blank">
                  <img class="friendly-link__img" src="../../assets/sc_ministry.png" alt="experimental_platform.jpeg" />
                </a>
                <a href="http://www.moe.gov.cn/" class="friendly-link-link" target="_blank">
                  <img class="friendly-link__img" src="../../assets/education_ministry.png"
                    alt="experimental_platform.jpeg" />
                </a>
                <a href="https://www.hhu.edu.cn/" class="friendly-link-link" target="_blank">
                  <img class="friendly-link__img" src="../../assets/hhu.png" alt="experimental_platform.jpeg" />
                </a>
              </div>
            </div>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getNewsList} from '../../api/news.js';
import { getInfoList} from '../../api/info.js';
import { getResearchList} from '../../api/research.js';
export default {
  created() {
    this.getNewsDataList();
    this.getInfoDataList();
    this.getResearchDataList();
  },

  data() {
    return {
      param:{},
      NewsList: [],
      InfoList: [],
      ResearchList: [],
      pastDataList:[],  //过滤数组
      
      needsForm: {
        article: '',
        mobile: '',
      },
      newsList: [
        {
          info: '安康市人民政府市长王浩一行来河海大学调研交流',
          time: '[23-04-17]',
          path: 'dn1'
        },
        {
          info: '水利部水循环与水动力系统重点实验室召开第一届学术委员会第一次会议',
          time: '[23-01-14]',
          path: 'dn2'
        },
        {
          info: '水利部部署加快推进2023年重大水利工程前期工作',
          time: '[22-12-30]',
          path: 'dn3'
        },
        {
          info: '加快构建国家水网 推进智慧水利建设',
          time: '[22-11-21]',
          path: 'dn4'
        },
        {
          info: '许峰副校长出席民盟河海大学委员会第六次代表大会',
          time: '[22-05-03]',
          path: 'dn5'
        },
      ],
      announcementsList: [
        {
          info: '第十一届国际项目管理协会研究大会暨第九届世界水谷论坛',
          time: '[23-04-21]',
          path: 'info1'
        },
        {
          info: '关于举办“2023年（第十一届）中国水利信息化技术论坛”的通知',
          time: '[23-03-15]',
          path: 'info2'
        },

        {
          info: '关于举办“2022（第十届）中国水利信息化技术论坛”的通知',
          time: '[22-07-02]',
          path: "info3"
        },
        {
          info: '第三届水利水电信息化和智能化发展前沿青年学术论坛(第二号通知)',
          time: '[22-03-29]',
          path: 'info4'
        },
        {
          info: "关于举办“2021中国水资源高效利用与节水技术论坛”的通知",
          time: '[21-08-17]',
          path: 'info5'
        },
      ],
      researchTrendsList: [
        {
          info: '雍斌教授在《Nature Communications》上发表研究成果',
          time: '[23-04-01]',
          path: "r1"
        },
        {
          info: '王卫光教授团队在国际顶级期刊Global Change Biology发表气候变化生态水文响应新成果',
          time: '[23-01-03]',
          path: "r2"
        },
        {
          info: '国家重点研发计划项目“长江水资源开发保护战略与关键技术研究”高质量通过绩效评价',
          time: '[22-08-29]',
          path: "r3"
        },
        {
          info: '王卫光教授团队在遥感领域顶级期刊《Remote Sensing of Environment》发表蒸散发估算新成果',
          time: '[22-07-02]',
          path: "r4"
        },
        {
          info: '国家重点研发计划课题“变化环境下流域水文气象极端事件演变规律及超标准洪水致灾机理”顺利通过综合绩效评价',
          time: '[22-01-25]',
          path: "r5"
        },
      ],
      teamsList: [
        {
          info: '水利多源数据融合与集成',
          time: '[22-03-29]',
        },
        {
          info: '多模态数据智能认知技术',
          time: '[22-03-29]',
        },
        {
          info: '水利大数据驱动的模型与模拟',
          time: '[22-03-29]',
        },
        {
          info: '水利大数据高效计算与服务',
          time: '[22-03-29]',
        },
      ],
      achievementsList: [
        {
          info: '海量数据驱动的水文多要素监测预报关键技术与应用',
          time: '[22-03-29]',
        },
        {
          info: '机载雷达高分辨率成像和高精度地面动目标检测技术',
          time: '[22-03-29]',
        },
        {
          info: '面向云端融合的大规模分布式数据处理支撑平台及产业化应用',
          time: '[22-03-29]',
        },
        {
          info: '水文大数据驱动的洪水预报模型关键技术与应用',
          time: '[22-03-29]',
        },
        {
          info: '国家/流域/省级水利数据资源目录服务系统',
          time: '[22-03-29]',
        },
      ],
      carouselsList: [
        {
          id: '1',
          url: require('../../assets/b_0.jpg'),
        },
        {
          id: '2',
          url: require('../../assets/b_1.png'),
        },
        {
          id: '3',
          url: require('../../assets/b_2.jpg'),
        },
        {
          id: '4',
          url: require('../../assets/b_3.jpg'),
        },
        {
          id: '5',
          url: require('../../assets/b_4.jpg'),
        },
      ],
    }
  },
  methods: {
    getNewsList(){
      console.log("进入getNewsList方法了");
      this.$router.push({path:'NewsList'})
    },
    getNewsDataList(){
      console.log("进入getDataList方法了");
      getNewsList(1,5,this.param).then((resp)=>{
        console.log("调用getNewsList接口返回的数据是：",resp.data);
        const {code,message,data} = resp.data;
        if(code === '00000' && data && data.length != ""){
          this.NewsList = data.records;//获得查询数据
        }else{
          this.NewsList = [];
        }
      })
    },
    getInfoList(){
      console.log("进入getInfoList方法了");
      this.$router.push({path:'InfoList'})
    },
    getInfoDataList(){
      console.log("进入getDataList方法了");
      getInfoList(1,5,this.param).then((resp)=>{
        console.log("调用getInfoList接口返回的数据是：",resp.data);
        const {code,message,data} = resp.data;
        if(code === '00000' && data && data.length != ""){
          this.InfoList = data.records;//获得查询数据
        }else{
          this.InfoList = [];
        }
      })
    },
    getResearchList(){
      console.log("进入getResearchList方法了");
      this.$router.push({path:'ResearchList'})
    },
    getResearchDataList(){
      console.log("进入getDataList方法了");
      getResearchList(1,5,this.param).then((resp)=>{
        console.log("调用getResearchList接口返回的数据是：",resp.data);
        const {code,message,data} = resp.data;
        if(code === '00000' && data && data.length != ""){
          this.ResearchList = data.records;//获得查询数据
        }else{
          this.ResearchList = [];
        }
      })
    },
    goToDirectDetail(){
      // 跳转到指定页面
      this.$router.push({ path: '/lab', query: { myfirstTitle: '2', mysecondTitle: '2-3' } });
    },
    submitNeeds() {
      alert('提交成功！')
    },
    notion(){
      alert('实验平台正在建设中，敬请期待！')
    },
    
  },
  
}

</script>

<style lang="less" scoped>
.carousel {
  padding: 0 !important;
}

.carousel__img {
  width: 100%;
  height: 100%;
}

.el-row {
  padding: 20px;
}

.text {
  font-size: 14px;
}

.item {
  display: flex;
  margin-bottom: 18px;
}

.clearfix {
  margin-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
}

.card-title {
  background-color: #0064c8;
  float: left;
  padding: 5px;
  border-radius: 5px 5px 0 0;
  color: #fff;
}

.news__link {
  flex: 1;
  text-align: left;
  justify-content: left;
  overflow: hidden;
  color: #000;
  text-decoration: none;
  white-space: nowrap;
}

.time {
  width: 100px;
}

.cube {
  width: 280px;
  height: 292px;
  box-sizing: border-box;
  overflow: hidden;
}

.experimental-platform {
  border-top: 2px solid #2eb6ce;
  background-color: #dbf4f8;
  position: relative;
}

.needs-collection__wrapper {
  border-top: 2px solid #d3d8dc;
  background-color: #e9eef2;
  padding: 0 10px;
}

.friendly-link__wrapper {
  border-top: 2px solid #46b98a;
  background-color: #0379d0;
}

.cube__title {
  font-size: 18px;
  line-height: 40px;
  margin-bottom: 5px;
}

.experimental-platform__title {
  color: #28aac1;
}

.needs-collection__title {
  color: #0064c8;
}

.friendly-link__title {
  color: #40ac80;
}

.cube__img {
  width: 260px;
  height: 245px;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0 auto;
}

.experimental-platform__img {
  height: 235px;
}

.friendly-link__img {
  width: 260px;
  height: 55px;
}

.experimental-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.experimental-btn-link {
  display: block;
  width: 220px;
  height: 35px;
  font-size: 16px;
  border-radius: 3px;
  color: #fff;
  text-decoration: none;
  line-height: 35px;
  text-align: center;
  background-color: #2eb6ce;
}

.friendly-link-link {
  display: block;
  width: 260px;
  height: 55px;
  text-decoration: none;
  margin-bottom: 5px;
}

.needs-collection__btn {
  width: 100% !important;
}

.index__footer {
  padding: 0;
  width: 100%;
}

.footer__wrapper {
  background-color: #409eff;
  width: 100%;
  padding: 5px 16px;
  box-sizing: border-box;
}

.footer__link {
  padding: 0 10px;
  border-right: 1px solid #909399;
  color: #fff;
}

.footer__link:first-child {
  padding-left: 0;
}

.footer__link:last-child {
  border-right: none;
}

</style>